module.exports = __webpack_public_path__ + "img/previo3.75a09267.png";